import React, { useEffect, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import {
  DivStatus,
  DivTooltip,
  HistoricoContainer,
  HistoricoContent,
  HistoricoH4,
  HistoricoH5,
  HistoricoH6,
  ItemContainer
} from './styles/ItemRedacaoStyle';
import Axios from 'axios';
import { API_HOST } from '../../consts';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Tooltip } from '@material-ui/core';
import { toast } from 'react-toastify';

const MAX_CHARACTERS_TO_DISPLAY = 50;

const ListPedidosDeAgendamento = ({
  redacaoTema,
  user,
  setUpdateTema,
  updateTema,
  requestStatus = ''
}) => {
  const [activeTab, setActiveTab] = useState('proposta');
  const [historyInfo, setHistoryInfo] = useState([]);
  const [anchorEl, setAnchorEl] = useState({});

  const fetchHistory = async () => {
    const res = await Axios.get(
      `${API_HOST}/redacao_temas/pedidos?tema=${redacaoTema.id}&status=${requestStatus}`
    );
    setHistoryInfo(res.data);
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  const handleClickMenu = (e, pedidoId) => {
    setAnchorEl((prev) => ({
      ...prev,
      [pedidoId]: e.currentTarget
    }));
  };

  const handleCloseMenu = (pedidoId) => {
    setAnchorEl((prev) => ({
      ...prev,
      [pedidoId]: null
    }));
  };

  const toggle = (tab) => {
    setActiveTab(tab);
  };

  const handleAprovar = async (id) => {
    const params = { status: 2, tema: redacaoTema.id };
    await Axios.get(`${API_HOST}/redacao_temas/pedidos/${id}/aprovar`, params)
      .then((res) => {
        console.log(res.data);
        if (res.data) {
          window.open(`${res.data}`, '_blank');
        }
        toast.success('Tema aprovado com sucesso.');
        fetchHistory();
        setUpdateTema(!updateTema);
      })
      .catch((err) => {
        console.error(err);
        toast.error(
          'Ocorreu um erro durante o processo de aprovação do agendamento.'
        );
      });
  };
  const handleRedirecionAgendamento = async (id, conferenciaEstudante) => {
    await Axios.get(
      `${API_HOST}/redacao_temas/pedidos/${id}/redireciona_para_agendamento?flag=${conferenciaEstudante}`
    )
      .then((res) => {
        if (res.data) {
          window.open(`${res.data}`, '_blank');
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error(
          'Ocorreu um erro durante o processo de aprovação do agendamento.'
        );
      });
  };
  const handleRedirecionCorrecoes = async (id) => {
    await Axios.get(
      `${API_HOST}/redacao_temas/pedidos/${id}/redireciona_para_correcoes`
    )
      .then((res) => {
        if (res.data) {
          window.open(`${res.data}`, '_blank');
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error(
          'Ocorreu um erro durante o processo de aprovação do agendamento.'
        );
      });
  };

  const handleReprovar = async (id) => {
    const params = { status: 3, tema: redacaoTema.id };
    await Axios.put(`${API_HOST}/redacao_temas/pedidos/${id}`, params);
    toast.success('Tema reprovado com sucesso.');
    fetchHistory();
    setUpdateTema(!updateTema);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 4:
        return { cor: '#2189E8', descricao: 'Agendado' };
      case 3:
        return { cor: '#F44336', descricao: 'Reprovado' };
      case 2:
        return { cor: '#4CAF50', descricao: 'Aprovado' };
      default:
        return { cor: '#FFC107', descricao: 'Aguardando análise' };
    }
  };

  return (
    <ItemContainer className="card-item card-alone">
      <Nav tabs>
        <NavItem>
          <NavLink
            className={classnames({
              active: activeTab === 'proposta'
            })}
            onClick={() => toggle('proposta')}
          >
            Proposta de Redação
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({
              active: activeTab === 'textos'
            })}
            onClick={() => toggle('textos')}
          >
            Textos Motivadores
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({
              active: activeTab === 'instrucoes'
            })}
            onClick={() => toggle('instrucoes')}
          >
            Instruções
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({
              active: activeTab === 'criterios'
            })}
            onClick={() => toggle('criterios')}
          >
            Critérios de Avaliação
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({
              active: activeTab === 'historico'
            })}
            onClick={() => toggle('historico')}
          >
            Histórico de Utilização
          </NavLink>
        </NavItem>
      </Nav>

      <div className="card-body no-radius-top">
        <TabContent activeTab={activeTab}>
          <TabPane tabId="proposta">
            <div
              className="html-container"
              dangerouslySetInnerHTML={{
                __html: redacaoTema.proposta_de_texto
              }}
            />
          </TabPane>
          <TabPane tabId="textos">
            {redacaoTema.textos_motivadores &&
              redacaoTema.textos_motivadores.map((texto) => (
                <div
                  className="html-container"
                  dangerouslySetInnerHTML={{ __html: texto.content }}
                />
              ))}
          </TabPane>
          <TabPane tabId="instrucoes">
            <ul>
              {redacaoTema.instrucoes &&
                redacaoTema.instrucoes.map((texto) => <li>{texto.nome}</li>)}
            </ul>
          </TabPane>
          <TabPane tabId="criterios">
            <ul>
              {redacaoTema.criterios &&
                redacaoTema.criterios.map((texto, index) => (
                  <li>{texto.nome}</li>
                ))}
            </ul>
          </TabPane>
          <TabPane tabId="historico">
            <HistoricoContainer>
              {historyInfo.length > 0 ? (
                historyInfo.map((pedido) => (
                  <HistoricoContent>
                    <HistoricoH4>
                      {`${pedido.escola_nome} | ${pedido.etapa_nome} | ${pedido.turma_nome}`
                        .length > MAX_CHARACTERS_TO_DISPLAY ? (
                        <Tooltip
                          disableFocusListener
                          disableTouchListener
                          title={`${pedido.escola_nome} | ${pedido.etapa_nome} | ${pedido.turma_nome}`}
                          placement="right-start"
                          arrow
                        >
                          <DivTooltip>
                            {`${pedido.escola_nome} | ${pedido.etapa_nome} | ${pedido.turma_nome}`}
                          </DivTooltip>
                        </Tooltip>
                      ) : (
                        `${pedido.escola_nome} | ${pedido.etapa_nome} | ${pedido.turma_nome}`
                      )}
                    </HistoricoH4>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <DivStatus cor={getStatusColor(pedido.status).cor}>
                        <HistoricoH5 cor={getStatusColor(pedido.status).cor}>
                          <Tooltip
                            disableFocusListener
                            disableTouchListener
                            title={`Solicitado por: ${pedido.criado_por} em ${pedido.criado_em}`}
                            placement="top"
                            arrow
                          >
                            <HistoricoH6>
                              {getStatusColor(pedido.status).descricao}
                            </HistoricoH6>
                          </Tooltip>
                        </HistoricoH5>
                      </DivStatus>
                      {getStatusColor(pedido.status).descricao ==
                        'Aguardando análise' &&
                      (user.logged_group.includes('ADMINISTRADOR') ||
                        user.logged_group.includes('PROFESSOR')) &&
                      redacaoTema.status !== 3 ? (
                        <>
                          <IconButton
                            aria-label="more"
                            aria-controls={`long-menu-${pedido.id}`}
                            aria-haspopup="true"
                            onClick={(e) => handleClickMenu(e, pedido.id)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            key={pedido.id}
                            className="menu-atividade"
                            id={`long-menu-${pedido.id}`}
                            anchorEl={anchorEl[pedido.id]}
                            keepMounted
                            open={Boolean(anchorEl[pedido.id])}
                            onClose={() => handleCloseMenu(pedido.id)}
                            PaperProps={{
                              style: {
                                maxHeight: 'fit-content',
                                width: 'fit-content'
                              }
                            }}
                          >
                            <MenuItem onClick={() => handleAprovar(pedido.id)}>
                              Aprovar
                            </MenuItem>
                            <MenuItem onClick={() => handleReprovar(pedido.id)}>
                              Reprovar
                            </MenuItem>
                          </Menu>
                        </>
                      ) : (
                        <>
                          <IconButton
                            aria-label="more"
                            aria-controls={`long-menu-${pedido.id}`}
                            aria-haspopup="true"
                            onClick={(e) => handleClickMenu(e, pedido.id)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            key={pedido.id}
                            className="menu-atividade"
                            id={`long-menu-${pedido.id}`}
                            anchorEl={anchorEl[pedido.id]}
                            keepMounted
                            open={Boolean(anchorEl[pedido.id])}
                            onClose={() => handleCloseMenu(pedido.id)}
                            PaperProps={{
                              style: {
                                maxHeight: 'fit-content',
                                width: 'fit-content'
                              }
                            }}
                          >
                            <MenuItem
                              onClick={() =>
                                handleRedirecionAgendamento(pedido.id, true)
                              }
                            >
                              Conferência de estudantes
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                handleRedirecionAgendamento(pedido.id, false)
                              }
                            >
                              Enviar arquivos para processamento
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                handleRedirecionCorrecoes(pedido.id, false)
                              }
                            >
                              Acompanhar Correções
                            </MenuItem>
                          </Menu>
                        </>
                      )}
                    </div>
                  </HistoricoContent>
                ))
              ) : (
                <HistoricoContent>
                  <HistoricoH5>Sem requisições</HistoricoH5>
                </HistoricoContent>
              )}
            </HistoricoContainer>
          </TabPane>
        </TabContent>
      </div>
    </ItemContainer>
  );
};

export default ListPedidosDeAgendamento;
